<template>
    <div id="groupcarddiv" class="divdisplay collectiontop-space-first-section">
        <input id="imageIdToSet" type="hidden" value="none">
        <div id="cropdivCroppie" class="popupDiv" style="top:5%;">
            <div id="imageareaCroppie">
            </div>
            <div id="controls_croppie">
                <input type="button" class="choose-image-btn" value="Choose Image" onclick="SubmitCroppie(), CloseCroppie(); return false;" />
                <div style="width: 10px; height: 10px; display: block; float: left;"></div>
                <input type="button" class="remove-img-btn" id="cropbutton" value="Delete Image" onclick="CloseCroppie(); return false;" />
                <input type="button" class="rotate-image-btn" id="rotateImage" value="Rotate Image" onclick="RotateImage(); return false;" />
            </div>
        </div>
        <!-- gif popup -->
        <div class="modal fade" id="gifLibrarySelect" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="gt-md-modal-header">

                        <h2>Choose an image</h2>
                        <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13"></path>
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1"></path>
                            </svg>
                        </div>

                    </div>
                    <!-- modal-header -->
                    <div class="gt-md-modal-content text-center pb-0 pt-3 pl-4 pr-4">

                        <div class="mt-library-tabs">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation" onclick="ToggleFooter('giphy'); return false;">
                                    <a class="nav-link active" id="gify-tab" data-toggle="tab" href="#gify" role="tab" aria-controls="library" aria-selected="true">Giphy</a>
                                </li>
                                <li class="nav-item" role="presentation" onclick="ToggleFooter('unsplash'); return false;">
                                    <a class="nav-link" id="unsplash-tab" data-toggle="tab" href="#unsplash" role="tab" aria-controls="giphy" aria-selected="false">Unsplash</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="giftabsContent">
                                <div class="tab-pane fade show active" id="gify" role="tabpanel" aria-labelledby="library-tab">

                                    <div class="mt-library-tab-content">
                                        <div class="col-sm-12 mt-3">
                                            <div class="row">
                                                <input placeholder="Search Library..." class="search-library-input" onkeyup='giphyObject.searchApi(); return false;' value="" id="giphySearch" maxlength="45" type="text">
                                                <div id="giphyApiSearchLoader" class="loader hidden"></div>
                                            </div>
                                        </div>
                                        <ul id="giphyImagesContainer">
                                        </ul>
                                    </div>
                                    <!-- mt-library-content -->

                                </div>
                                <div class="tab-pane fade" id="unsplash" role="tabpanel" aria-labelledby="unsplash-tab">

                                    <div class="mt-library-tab-content">
                                        <div class="col-sm-12 mt-3">
                                            <div class="row">
                                                <input placeholder="Search Library..." class="search-library-input" onkeyup='unsplashObject.searchApi(); return false;' value="" id="unSplashSearch" maxlength="45" type="text">
                                                <div id="unsplashApiSearchLoader" class="loader hidden"></div>
                                            </div>
                                        </div>
                                        <ul id="unsplashImagesContainer">
                                        </ul>
                                    </div>
                                    <!-- mt-library-content -->

                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- gt-md-modal-content -->
                </div>
            </div>
        </div>

        <!-- inspiration text popup -->
        <div class="modal fade gt-md-modal" id="description-examples" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog mt-8">
                <div class="modal-content">

                    <div class="gt-md-modal-header">

                        <h2>Message Suggestions</h2>
                        <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>
                        </div>

                    </div>
                    <!-- gt-md-modal-header -->


                    <div class="gt-md-modal-content">

                        <h2 class="font-16 text-center mb-5">Copy some or all of what we have provided to use as <br />your GroupCard message.</h2>

                        <div class="row">

                            <!--              @if (Model.Suggestions.Any())-->
                            <!--              {-->
                            <!--              foreach (var st in Model.Suggestions)-->
                            <!--              {-->
                            <!--              <div class="col-md-12 col-lg-12 hand-section">-->
                            <!--                <div class="text-box gts-textbox text-box-style anything-box1" style="margin-bottom:20px;">-->
                            <!--                  <div id="suggestion-@index" class="text-center">-->
                            <!--                    <p id="para-text-@index">-->
                            <!--                      @st-->
                            <!--                    </p>-->
                            <!--                  </div>-->
                            <!--                  <div class="m-auto w-33">-->
                            <!--                    <input type="button" class="theme-btn-lite mt-3" id="btn-thanks-coach" onclick="InsertSuggestion('para-text-@index');" value="Insert text"/>-->
                            <!--                  </div>-->
                            <!--                </div>-->
                            <!--              </div>-->
                            <!--              index++;-->
                            <!--              }-->
                            <!--              }-->

                        </div>
                    </div>
                    <!-- gt-md-modal-content -->
                </div>
            </div>
        </div>

        <img id="GroupCards[0].Pic-preview-sample" style="display:none;" />
        <div id="GroupCards[0].Name-preview-sample" class="gctilename gcpreviewtile">
            <span></span>
        </div>
        <!-- Preview or Share -->
        <section v-show="this.mode === 'Share'" class="invite-preview-header">

            <div class="row">
                <div class="col-md-4 d-flex align-items-center">
                    <div class="invite-preview-left">
                        <h2 class="position-relative">
                            <a href="javascript:void(0)" onclick="showHideDv('firstpagediv');">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                    <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                </svg>
                            </a>
                            Preview
                        </h2>
                    </div>
                </div>

                <div class="col-md-8 d-flex align-items-center">
                    <div class="invite-preview-right">

                        <button v-if="this.hasSession" @click="saveDraftCollection" class="theme-btn-lite">Publish & share</button>

                        <a v-else href="javascript:void(0)" target="_top" onclick="shareObj.moveNext('#collectionUrlFinal')" class="theme-btn-lite">Publish & share</a>

                        <a href="javascript:void(0)" class="theme-link-lite" onclick="window.parent.showEditModal()">Edit details</a>
                    </div>
                </div>
                <!-- col-md-6 -->
            </div>
        </section>
        <!-- End Preview or Share -->

        <section class="preview-bg min-100vh @previewClassforHeader previewClass defaultOverlay" data-id="groupcarddiv">

            <div class="preview-modal-btn-right bdpay">
                <a v-show="this.isGroupCardOnly && !this.hasSession" href="javascript:void(0)" @click="saveDraftCollection">
                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>

                <a v-show="this.isGroupCardOnly && this.hasSession" href="javascript:void(0)" @click="shareObj.moveNext('#collectionUrlFinal')">
                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>

                <a v-show="!this.isGroupCardOnly" href="javascript:void(0)" @click="showHideDv('showPaymentScreen');">
                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>

            </div>
            <!-- preview-modal-btn-right -->

            <div class="preview-modal-btn-left bdinvite">
                <a href="javascript:void(0)" @click="showHideDv('firstpagediv');">
                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2L2 14L14 26" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>

            </div>
            <!-- preview-modal-btn-left -->

            <div class="row no-gutters">
                <!--<div class="trigger-screen" ></div>-->
                <div class="col-lg-6 bg-lite">
                    <div class="mt-contribute-left mt-contribute-groupcard mt-card-space">

                        <a v-show="this.mode !== 'Preview' && this.mode !== 'Share' && groupCardId === 0" href="#" class="contributorPayment-back-arrow" @click="showHideDv('firstpagediv')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10"></path>
                                <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10"></path>
                            </svg>
                        </a>

                        <div class="mt-contribute-groupcard-inner">
                            <div id="groupCardContributorCarousel">
                                <GroupCardContributorMain v-if="this.collection"
                                                          :collection="this.collection.collectionGuid" />
                                <!-- GroupCardCarousel component -->
                            </div>
                            <!--<div class="previewCarousel">
                                <a href="#">
                                    <svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 25L13 13L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                                See messages
                            </div>-->
                        </div>

                    </div>

                </div>

                <div class="col-lg-6 bg-white mt-mob-bg">

                    <div class="mt-contribute-right mt-48 position-relative mt-card-white">
                        <div class="mt-sign-card">
                            <div v-if="isEditGC">
                                <div class="mt-sign-card-inner">
                                    <h2>Sign the card</h2>
                                    <p>Write a message and add a photo <br /> to the card</p>
                                    <input type="hidden" id="text-used" v-model="ImageUsed" name="text-used" />
                                    <input type="hidden" id="image-used" v-model="TextUsed" name="image-used" />
                                    <div class="mt-sign-card-form">
                                        <div class="mt-sign-control">

                                            <div class="row">
                                                <div class="col-6">
                                                    <label>First name</label>
                                                    <input type="text" @input="gconchange" name="FirstName" id="FirstName" v-model="messagedb.FirstName" placeholder="First name" maxlength="45" />
                                                    <div class="d-block">
                                                        <label v-show="firstNameValid" style="color: red; font-size: 14px; font-weight: 400;">First Name is required</label>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <label>Last name</label>
                                                    <input type="text" @input="gconchange" name="LastName" id="LastName" v-model="messagedb.LastName" placeholder="Last name" maxlength="45" />
                                                    <div class="d-block">
                                                        <label v-show="lastNameValid" style="color: red; font-size: 14px; font-weight: 400;">Last Name is required</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- row -->
                                           
                                            

                                        </div>
                                        <hr />

                                        <!-- mt-sign-card-form -->
                                        <div class="mt-sign-control">
                                            <label>Message</label>
                                            <div class="mt-sign-textarea comment-div" id="CommentOld" v-html="messagedb.Message" @blur="updateHtml" placeholder="Start typing" maxlength="1000" contenteditable="true"></div>
                                            <a href="#" class="like-suggestions" v-if="inspirationTexts.length > 0" data-toggle="modal" data-target="#group-card-inspiration">Need inspiration?</a>
                                            <label v-show="messageValid" style="color: red; font-size: 14px; font-weight: 400;">Message is required</label>

                                        </div>
                                        <hr />
                                        <div class="mt-sign-control border-bottom-0 mb-0 pb-0">
                                            <label>Add an image or GIF</label>
                                            <div class="d-flex justify-content-between" id="browseImage">
                                                <div>
                                                    <button class="mt-browse-library" type="button" @click="showBrowseLibrary">Browse our library</button>
                                                </div>
                                                <div class="mt-upload-own">
                                                    <button>Upload your own</button>
                                                    <input type="file" id="file" accept=".gif, .jpg, .jpeg, .bmp, .png" @change="loadImageinBoxCover" ref="imageInputEdit" />
                                                </div>
                                            </div>
                                            <div class="mt-3" id="previewPicDiv">
                                                <div class="mt-card-image-preview position-relative d-inline-block">

                                                    <img v-if="messagedb.ImageUrl === ''" id="GroupCards[0].Pic-preview" src="https://grouptogether.blob.core.windows.net/images/no_pic.jpg" alt="Group Card Image"
                                                         style="width: 125px; height:125px" />

                                                    <img v-else id="GroupCards[0].Pic-preview" :src="messagedb.ImageUrl" alt="" style="width: 125px; height:125px" />

                                                    <a href="#" @click="removeImageTile">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16">
                                                            <path fill="#1e2437" fill-opacity="0.4"
                                                                  d="M 15 0 H 1 C 0.4 0 0 0.4 0 1 V 15 C 0 15.6 0.4 16 1 16 H 15 C 15.6 16 16 15.6 16 15 V 1 C 16 0.4 15.6 0 15 0 Z M 11.5 10.1 L 10.1 11.5 L 8 9.4 L 5.9 11.5 L 4.5 10.1 L 6.6 8 L 4.5 5.9 L 5.9 4.5 L 8 6.6 L 10.1 4.5 L 11.5 5.9 L 9.4 8 L 11.5 10.1 Z" />
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>

                                        <!-- mt-sign-control -->
                                    </div>
                                    <!-- mt-sign-card-form -->

                                    <div class="mt-profile-checkbox mt-4 mb-5 hidden">
                                        <label class="">
                                            Keep my message private <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="mt-3">
                                        <a href="#" class="theme-btn-lite" id="signonly-button" @click="EditGroupCard">
                                            Finish
                                        </a>
                                        <span class="mt-tagline mt-3 payment-block">By continuing you agree to GroupTogether <a href="https://grouptogether.com/terms" target="_blank" rel="noopener">Terms</a> &amp; <a href="https://grouptogether.com/privacy" target="_blank">Privacy Policy</a>.</span>

                                    </div>

                                </div>
                            </div>
                            <div v-else class="mt-sign-card-inner">
                                <h2>Sign the card</h2>
                                <p>Write a message and add a photo <br /> to the card</p>

                                <div class="mt-sign-card-form">
                                    <div class="mt-sign-control">

                                        <div class="row">
                                            <div class="col-6">
                                                <label>First name</label>
                                                <input type="text" @input="gconchange" name="FirstName" id="FirstName" v-model="messagedb.FirstName" placeholder="First name" maxlength="45" />
                                                <div class="d-block">
                                                    <label v-show="firstNameValid" style="color: red; font-size: 14px; font-weight: 400;">First Name is required</label>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <label>Last name</label>
                                                <input type="text" @input="gconchange" name="LastName" id="LastName" v-model="messagedb.LastName" placeholder="First name" maxlength="45" />
                                                <div class="d-block">
                                                    <label v-show="lastNameValid" style="color: red; font-size: 14px; font-weight: 400;">Last Name is required</label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- row -->
                                        
                                       

                                    </div>
                                    <hr />

                                    <div v-show="signonly || this.collection.collectionSetupType === 'FGC + Gift'" class="mt-sign-control" id="emailDiv">
                                        <label>
                                            Email
                                            <span class="notification-badge cursor-pointer" data-toggle="tooltip" data-placement="top" title="We email you a copy of your message and photo with a link in case you need to edit it.">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM9.5 8.4C9 8.7 9 8.8 9 9V10H7V9C7 7.7 7.8 7.1 8.4 6.7C8.9 6.4 9 6.3 9 6C9 5.4 8.6 5 8 5C7.6 5 7.3 5.2 7.1 5.5L6.6 6.4L4.9 5.4L5.4 4.5C5.9 3.6 6.9 3 8 3C9.7 3 11 4.3 11 6C11 7.4 10.1 8 9.5 8.4Z"
                                                          fill="#1E2437" fill-opacity="0.4" />
                                                </svg>
                                            </span>
                                        </label>
                                        <input type="email" @input="gconchange" id="Email" name="Email" v-model="messagedb.Email" placeholder="xxx@xxxxxx.xxx" autocomplete="off" />
                                        <label v-show="emailValid" style="color: red; font-size: 14px; font-weight: 400;">Email is required</label>

                                        <hr />
                                    </div>

                                    <!-- mt-sign-card-form -->
                                    <div class="mt-sign-control">
                                        <label>Message</label>
                                        <div class="mt-sign-textarea comment-div" id="CommentOld" v-html="messagedb.Message" @blur="updateHtml" placeholder="Start typing" maxlength="1000" contenteditable="true"></div>
                                        <a href="#" class="like-suggestions" v-if="inspirationTexts.length > 0" data-toggle="modal" data-target="#group-card-inspiration">Need inspiration?</a>
                                        <label v-show="messageValid" style="color: red; font-size: 14px; font-weight: 400;">Message is required</label>

                                    </div>
                                    <hr />
                                    <div class="mt-sign-control border-bottom-0 mb-0 pb-0">
                                        <label>Add an image or GIF</label>
                                        <div class="d-flex justify-content-between" id="browseImage">
                                            <div>
                                                <button class="mt-browse-library" type="button" @click="showBrowseLibrary">Browse our library</button>
                                            </div>
                                            <div class="mt-upload-own">
                                                <button>Upload your own</button>
                                                <input id="thisPicSrc-GroupCards[0].Pic" type="hidden" value="none" onchange="SetImage(this,0);">
                                                <input type="file" id="file" @change="loadImageinBoxCover" accept=".gif, .jpg, .jpeg, .bmp, .png" ref="imageInputEdit" />
                                            </div>
                                        </div>
                                        <div class="mt-3" id="previewPicDiv">
                                            <div class="mt-card-image-preview position-relative d-inline-block">

                                                <img v-if="messagedb.ImageUrl === ''" id="GroupCards[0].Pic-preview" src="https://grouptogether.blob.core.windows.net/images/no_pic.jpg" alt="Group Card Image"
                                                     style="width: 125px; height:125px" />

                                                <img v-else id="GroupCards[0].Pic-preview" :src="messagedb.ImageUrl" alt="" style="width: 125px; height:125px" />

                                                <a href="#" @click="removeImageTile">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16">
                                                        <path fill="#1e2437" fill-opacity="0.4"
                                                              d="M 15 0 H 1 C 0.4 0 0 0.4 0 1 V 15 C 0 15.6 0.4 16 1 16 H 15 C 15.6 16 16 15.6 16 15 V 1 C 16 0.4 15.6 0 15 0 Z M 11.5 10.1 L 10.1 11.5 L 8 9.4 L 5.9 11.5 L 4.5 10.1 L 6.6 8 L 4.5 5.9 L 5.9 4.5 L 8 6.6 L 10.1 4.5 L 11.5 5.9 L 9.4 8 L 11.5 10.1 Z" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- mt-sign-control -->
                                </div>
                                <!-- mt-sign-card-form -->

                                <div class="mt-profile-checkbox mt-4 mb-5 hidden">
                                    <label class="">
                                        Keep my message private <span class="checkmark"></span>
                                    </label>
                                </div>

                                <div v-if="!signonly && collection.collectionSetupType != 'FGC + Gift'" class="mt-3">
                                    <a href="#" class="theme-btn-lite" id="groupcard-button" @click="saveGroupCardInfo">
                                        Next
                                    </a>

                                </div>
                                <div v-else class="mt-3">
                                    <a href="#" class="theme-btn-lite" id="signonly-button" @click="SignOnly">
                                        Finish
                                    </a>
                                    <span class="mt-tagline mt-3 payment-block">By continuing you agree to GroupTogether <a href="https://grouptogether.com/terms" target="_blank" rel="noopener">Terms</a> &amp; <a href="https://grouptogether.com/privacy" target="_blank">Privacy Policy</a>.</span>

                                </div>

                            </div>
                        </div>
                        <!-- mt-sign-card -->
                    </div>
                    <!-- mt-contribute-right -->

                </div>
                <!-- md-6 -->
            </div>
            <!-- row -->

        </section>
        <GroupCardOptionsImageLibrary v-if="collection" @update-image="updateImageUrl" />
        <!-- GroupCardOptionsImageLibrary component -->

        <GroupCardOptionsInspirationText v-if="collection && inspirationTexts.length > 0" :inspirationTexts="inspirationTexts" @update-inspiration="updateText" />
        <!-- GroupCardOptionsInspirationText component -->
    </div>
    <div id="imageContainerCustom" style="text-align: center; display: none;"></div>
    <!--<div id="res" class="img_upload_base res croppieImage" onclick="document.getElementById('myfileCustom').value = ''; readCustom(document.getElementById('myfileCustom'));">
        <img id="ImgPreCustom" class="ImgPreview inv_img" src="@Model.InvitationUploadedImage" alt="No Image" style="width:100%;">
    </div>-->

    <div class="modal fade gt-md-modal" id="image_large_popup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog mt-8 max-610">
            <div class="modal-content">

                <div class="gt-md-modal-header">

                    <h2>Oops!</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                        </svg>
                    </div>

                </div>
                <!-- gt-md-modal-header -->
                <div class="gt-md-modal-content text-center">

                    <p class="mb-3">The image you are trying to upload exceeds the maximum allowed limit.</p>
                    <p>Try uploading an image with a size lower than 5MB</p>


                    <div class="pt-4 pb-2">
                        <a href="#" class="theme-btn-dark max-180" data-dismiss="modal">OK</a>
                    </div>


                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>


    <div id="cropdivCover" class="popupDiv" style="top:5%;">
        <!--<div style="display: none;">-->
        <input id="xC" type="hidden" name="xC" style="width: 60px;" />
        <input id="yC" type="hidden" name="yC" style="width: 60px;" />
        <input id="x2C" type="hidden" name="x2C" style="width: 60px;" />
        <input id="y2C" type="hidden" name="y2C" style="width: 60px;" />
        <input id="wC" type="hidden" name="wC" style="width: 60px;" />
        <input id="hC" type="hidden" name="hC" style="width: 60px;" />
        <!--</div>-->
        <div id="imageareaCover">
        </div>
        <div id="controls_croppie">
            <input type="image" src="https://grouptogether.blob.core.windows.net/images/btn_crop_ok.png" @click="submitimageCover(), fadeoutCover();" />
            <div style="width: 10px; height: 10px; display: block; float: left;"></div>
            <input type="image" id="cropbutton" src="https://grouptogether.blob.core.windows.net/images/btn_crop_cancel.png" @click="fadeoutCover();" />
        </div>
    </div>
    <input type="hidden" id="imageurlCover" name="imageurlCover">
    <input type="hidden" id="imagepathCover" name="imagepathCover" />
</template>

<script>

    import GroupCardContributorMain from './GroupCardContributorMain'
    import GroupCardOptionsInspirationText from './GroupCardOptionsInspirationText.vue'
    import GroupCardOptionsImageLibrary from './GroupCardOptionsImageLibrary.vue'
    export default {
        name: "GroupCardPreview",
        components: {
            GroupCardContributorMain,
            GroupCardOptionsInspirationText,
            GroupCardOptionsImageLibrary
        },
        props: ['signonly', 'mode', 'hasSession', 'isGroupCardOnly', 'hasGroupCard', 'collection', 'inspirationTexts', 'showHideDiv', 'invId', 'characterLimit', 'messagedb', 'isEditGC'],
        data() {
            return {
                messageChars: 0,
                fromValid: false,
                firstNameValid: false,
                lastNameValid: false,
                messageValid: false,
                emailValid: false,
                message: {
                    Id: 0,
                    From: "",
                    Message: "",
                    FirstName: "",
                    LastName: "",
                    ImageUrl: "",
                    ContriId: ""
                },
                giftCardImageUrl: '',
                groupCardId: 0,
                from: '',
                email: '',
                comment: '',
                picUrl: '',
                TextUsed: '0',
                TextUsed: '0'

            }
        },
        mounted: function () {
            this.messageChars = 0
            $(function () {
                window.parent.$('[data-toggle="tooltip"]').tooltip();
                window.parent.setEditableDiv();
            })
        },
        methods: {
            async loadImageinBoxCover() {

                var that = this
                let input = this.$refs.imageInputEdit
                //error if image size exceeds 5MB limit
                if (input.files[0].size > 5242880) {
                    $("#image_large_popup").modal()
                    $("#imageContainer").html($("#imageContainer").html())
                    return
                }
                var reader = new FileReader();
                if (input.files[0].type != "image/gif") {
                    // The following size is how big we want the final image to be
                    var targetWidth = 450;
                    var targetHeight = 300;
                    // The following is the size of the editing modal we want. In this case, 50% of the user's screen.
                    var modalViewportWidth = $(window).width() * 0.5 // 50%
                    var modalViewportHeight = $(window).height() * 0.75 // 75%
                    if (input.files && input.files[0]) {
                        reader.onload = function (e) {
                            $("#imageareaCover").html('<img src="' + e.target.result + '" id="cropimage" class="imgCover" /><br />')
                            $("#imageurlCover").val(e.target.result)
                            var aspectratio = targetWidth / targetHeight
                            // image added load event
                            $(".imgCover").on('load', function () {
                                that.$nextTick(() => {
                                    // putting the crop tool on the image
                                    $(".imgCover").Jcrop({
                                        onChange: showCoordsCover,
                                        onSelect: showCoordsCover,
                                        setSelect: [0, 0, targetWidth, targetHeight],
                                        boxWidth: modalViewportWidth,
                                        boxHeight: modalViewportHeight
                                    });
                                });
                            });
                            $("#cropdivCover").fadeIn();
                        };
                        reader.readAsDataURL(input.files[0]);
                    }
                    $("#cropdivCover").fadeIn();
                    $("body").before('<div class="modalOverlayTemplate"></div>');
                }
                else {
                    reader.readAsDataURL(input.files[0]);
                    this.$emit('showLoadScreen');
                    var formdata = new FormData();
                    var fileCover = input.files[0];
                    console.log(input.files[0]);
                    formdata.append("imageFile", fileCover);
                    const url = `${window.location.origin}/image/GifTransformForGroupCard`;
                    await this.axios.post(url, formdata,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((resp) => {

                            this.$emit('hideLoadScreen');
                            document.getElementById("imageurlCover").value = resp.data.imageURL;
                            var lastImgSet = document.getElementById("imageIdToSet");
                            var tempImageSrc = document.getElementById("GroupCards[0].Pic-preview");
                            tempImageSrc.src = "data:image/gif;base64," + resp.data.imageData;
                            $('#previewPicDiv').show();
                            this.updateNewImageUrl(resp.data.imageURL);
                        })
                        .catch((err) => {
                            console.error(err);
                        })
                }

            },
            updateNewImageUrl(ImageUrl) {
                this.message.ImageUrl = ImageUrl;
                this.messagedb.ImageUrl = ImageUrl;
            },
            fadeoutCover() {
                $('#cropdivCover').fadeOut();
                $(".modalOverlayTemplate").remove();
            },
            async submitimageCover() {

                var url = $("#imageurlCover").val();
                $("#imagepathCover").val(url);

                var x = Math.round($('#xC').val());
                var y = Math.round($('#yC').val());
                var x2 = Math.round($('#x2C').val());
                var y2 = Math.round($('#y2C').val());
                var w = Math.round($('#wC').val());
                var h = Math.round($('#hC').val());
                var targetWidth = w
                var targetHeight = h

                // This means the browser supports async file uploads.
                if (window.FormData) {
                    var formdata = new FormData();
                    var fileCover = this.$refs.imageInputEdit.files[0];
                    formdata.append("x", x);
                    formdata.append("y", y);
                    formdata.append("x2", x2);
                    formdata.append("y2", y2);
                    formdata.append("w", targetWidth);
                    formdata.append("h", targetHeight);
                    formdata.append("image", fileCover);
                    //formdata.append("collection", gcSetupObj.collection);
                    //ajax call to save image
                    const url = `${window.location.origin}/image/TransformImageGroupCardCover`;
                    await this.axios.post(url, formdata, {
                        headers: {
                            /*'Content-Type': 'application/json'*/
                        }
                    }).then((resp) => {

                        this.updateNewImageUrl(resp.data);
                    })
                        .catch((err) => {
                            console.error(err);
                        })

                }
            },
            showHideDv(divId) {
                this.$emit('showHideDiv', divId)
            },
            updateImageUrl(imageUrl) {
                this.messagedb.ImageUrl = imageUrl
            },
            updateHtml: function (e) {
                this.gconchange();
                this.html = e.target.innerHTML;
                this.message.Message = this.html;
                this.messagedb.Message = this.html;
            },
            updateText(text) {
                this.messagedb.Message = this.messagedb.Message + text
                this.gconchange();
            },
            showBrowseLibrary() {
                //show popup
                $("#group-card-browse-library").modal();
                $(".modal-backdrop").addClass("z-index-50");
            },
            onFileChange(e) {
                this.error = null;
                this.errorMessage = "";
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                if (files[0].size > 5242880) {
                    this.error = true;
                    this.errorMessage = "The image you are trying to upload exceeds the maximum allowed limit. Try uploading an image with size lower than 5MB.";
                }
                else {
                    this.submitImage(this.$refs.file.files[0]);
                }

            },

            async submitImage(file) {
                this.$emit('showLoadScreen');
                let formData = new FormData();
                formData.append('file', file);

                const url = `${window.location.origin}/image/transformforgroupcard`;
                await this.axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((resp) => {
                    this.message.ImageUrl = resp["data"].imageURL;
                    this.$emit('hideLoadScreen');
                })
                    .catch((err) => {
                        console.error(err);
                        this.$emit('hideLoadScreen');
                    })
            },
            showInspiration() {
                $("#group-card-inspiration").modal();
                $(".modal-backdrop").addClass("z-index-50");
            },
            hideGroupCard(e) {
                this.$emit('showHideDiv', 'showPaymentScreen')
            },
            saveDraftCollection() {
                const url = '/invite/share?collection=' + this.collection.collectionGuid;
                this.$emit("saveDraft", url)
            },
            gconchange() {
                
                this.firstNameValid = false;
                this.lastNameValid = false;
                this.messageValid = false;
                this.emailValid = false;
            },

            async saveGroupCardInfo() {
                if (this.messagedb.FirstName.trim() === "") {
                    this.firstNameValid = true;
                    return false;
                }
                if (this.messagedb.LastName.trim() === "") {
                    this.lastNameValid = true;
                    return false;
                }
                if (this.messagedb.Message === "" || this.messagedb.Message === "<div><br></div>" || this.messagedb.Message === "<br>") {
                    this.messageValid = true;
                    return false;
                }
                this.$emit('showLoadScreen');
                this.$emit('GetGroupCardFrom', this.messagedb.FirstName , this.messagedb.LastName)
                this.$emit('GetGroupCardMessage', this.messagedb.Message)
                this.$emit('GetGroupCardImageUrl', this.messagedb.ImageUrl)
                const url = `${window.location.origin}/Payments/GroupCardLog`;
                await this.axios.post(url, JSON.stringify({ From:"",firstName: this.messagedb.FirstName ,lastName: this.messagedb.LastName, comment: this.messagedb.Message, invId: this.invId, collectionId: this.collection.collectionId, picUrl: this.messagedb.ImageUrl }), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((resp) => {
                        if (this.signonly) {
                            var url = `${window.top.location.origin}/payment-confirmed`;
                            window.location.href = url;
                        } else {
                            this.$emit('showHideDiv', 'showPaymentScreen')
                            this.$emit('hideLoadScreen');
                        }

                    })
                    .catch((err) => {
                        console.error(err);
                        this.$emit('hideLoadScreen');
                    })
            },
            async SignOnly() {
                if (this.messagedb.FirstName === "") {
                    this.firstNameValid = true;
                    return false;
                }
                if (this.messagedb.LastName === "") {
                    this.lastNameValid = true;
                    return false;
                }
                //if (this.messagedb.From === "") {
                //    this.fromValid = true;
                //    return false;
                //}
                if (this.messagedb.Email === "") {
                    this.emailValid = true;
                    return false;
                }

                if (this.messagedb.Message === "" || this.messagedb.Message === "<div><br></div>" || this.messagedb.Message === "<br>") {
                    this.messageValid = true;
                    return false;
                }

                this.$emit('showLoadScreen');
                const url = `${window.location.origin}/Payments/SaveGConly`;
                await this.axios.post(url, JSON.stringify({ From: "", firstName: this.messagedb.FirstName, lastName: this.messagedb.LastName, Email: this.messagedb.Email, comment: this.messagedb.Message, invId: this.invId, collectionId: this.collection.collectionId, picUrl: this.messagedb.ImageUrl }), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((resp) => {
                        if (this.signonly || this.collection.collectionSetupType === 'FGC + Gift') {
                            var url = `${window.top.location.origin}/payment-confirmed`;
                            window.location.href = url;
                        }

                    })
                    .catch((err) => {
                        console.error(err);
                        this.$emit('hideLoadScreen');
                    })
            },
            async EditGroupCard() {
                //if (this.messagedb.From === "") {
                //    this.fromValid = true;
                //    return false;
                //}
                //if (this.email === "") {
                //    this.emailValid = true;
                //    return false;
                //}
                if (this.messagedb.FirstName === "") {
                    this.firstNameValid = true;
                    return false;
                }
                if (this.messagedb.LastName === "") {
                    this.lastNameValid = true;
                    return false;
                }
                if (this.messagedb.Message === "" || this.messagedb.Message === "<div><br></div>" || this.messagedb.Message === "<br>") {
                    this.messageValid = true;
                    return false;
                }

                this.$emit('showLoadScreen');
                const url = `${window.location.origin}/Payments/EditGroupCard`;
                await this.axios.post(url, JSON.stringify({ from: "", firstName: this.messagedb.FirstName, lastName: this.messagedb.LastName, email: this.messagedb.Email, comment: this.messagedb.Message, collectionId: this.collection.collectionId, picUrl: this.messagedb.ImageUrl, Id: this.messagedb.Id, ImageUsed: this.ImageUsed, TextUsed: this.TextUsed }), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((resp) => {
                        var url = `${window.top.location.origin}/payment-confirmed`;
                        window.location.href = url;
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$emit('hideLoadScreen');
                    })
            },
            removeImageTile() {
                this.messagedb.ImageUrl = null
            },
            getImage(displayImage) {
                var imageFile = document.getElementById(displayImage.id.replace("imgtoset-", ""));
                var imageIdToSet = document.getElementById("imageIdToSet");
                imageIdToSet.value = displayImage.id.replace("imgtoset-", "");
                imageFile.value = "";
                imageFile.click();
            },
            setImage(imgSrc, ind) {
                var imgControl = document.getElementById(document.getElementById("imageIdToSet").value + "-preview");
                var imgControl2 = document.getElementById(document.getElementById("imageIdToSet").value + "-preview-sample");
                imgControl.setAttribute("src", imgSrc.value);
                imgControl2.setAttribute("src", imgSrc.value);
                var fbPic = document.getElementById(document.getElementById("imageIdToSet").value + "-fb");
                fbPic.value = "";
            },




        }
    }
</script>

<style scoped>
    .popupDiv {
        position: fixed;
        left: 50%;
        transform: translate(-50%, 0);
        top: 13%;
        z-index: 100000000;
        display: none;
        text-align: center;
        margin: 10px auto;
        background-color: rgba(0, 0, 0, 0.85);
        border: #666 medium solid;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        html-border-radius: 5px;
    }
</style>